import { ExternalLink } from "lucide-react";

// Why a connection is needed and where its key comes from. It reads either shape a catalog guide has had:
// the long one (subtitle, time, account, why, steps, links, reminder) and the short one (title, steps, url).

export function guideLinks(guide) {
  const links = Array.isArray(guide?.links) ? guide.links.filter((link) => link?.url) : [];
  if (guide?.url && !links.some((link) => link.url === guide.url)) links.push({ url: guide.url, label: guide.linkLabel || "Open it" });
  return links;
}

export function GuideBlock({ guide, title }) {
  if (!guide) return null;
  const steps = Array.isArray(guide.steps) ? guide.steps : [];
  const links = guideLinks(guide);
  const hasMeta = guide.estimatedTime || guide.accountContext;
  return (
    <section className="cx-guide" data-testid="connection-guide">
      <h3 className="cx-guide__title">{title || guide.title}</h3>
      {guide.subtitle ? <p className="cx-guide__subtitle">{guide.subtitle}</p> : null}
      {hasMeta ? (
        <dl className="cx-guide__meta">
          {guide.estimatedTime ? <div><dt>Takes about</dt><dd>{guide.estimatedTime}</dd></div> : null}
          {guide.accountContext ? <div><dt>Use this account</dt><dd>{guide.accountContext}</dd></div> : null}
        </dl>
      ) : null}
      {guide.whyNeeded ? <p className="cx-guide__why"><strong>Why</strong>{guide.whyNeeded}</p> : null}
      {steps.length ? <ol className="cx-guide__steps">{steps.map((step, index) => <li key={index}>{step}</li>)}</ol> : null}
      {links.length ? (
        <div className="cx-guide__links">
          {links.map((link) => (
            <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer" className="cx-guide__link">{link.label || link.url}<ExternalLink size={13} aria-hidden="true" /></a>
          ))}
        </div>
      ) : null}
      {guide.reminder ? <p className="cx-guide__reminder">{guide.reminder}</p> : null}
    </section>
  );
}

export default GuideBlock;
